// components/SearchField.tsx
import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

interface Props {
  value: string;
  placeholder?: string;
  onChange: (v: string) => void;
  onSearch: () => void;
}

const SearchField: React.FC<Props> = ({
  value,
  placeholder = "Search",
  onChange,
  onSearch,
}) => {
  return (
    <TextField
      fullWidth
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && onSearch()}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={onSearch}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                  width: 36,
                  height: 36,
                  borderRadius: "3px",
                }}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchField;
